import React from 'react';
import { ForgeIcon } from '@tylertech/forge-react';

interface DragHandleIconProps {
  name?: string;
  slot?: string;
  style?: React.CSSProperties;
  isDraggable?: boolean;
}

export const DragHandleIcon: React.FC<DragHandleIconProps> = ({
  name = 'drag_handle',
  slot = 'leading',
  style,
  isDraggable = true,
}) => {
  // Merge drag state styles with provided styles
  const dragStyles: React.CSSProperties = {
    cursor: isDraggable ? 'grab' : 'not-allowed',
    opacity: isDraggable ? 1 : 0.3,
    ...style,
  };

  return <ForgeIcon name={name} slot={slot} style={dragStyles} />;
};
